import _ from 'lodash';
import geocode from '../app/geocode';

function updateCoordinates($el, lat, lng) {
  $el.find('#school_address_attributes_lat').val(lat);
  $el.find('#school_address_attributes_lng').val(lng);
  $el.find('input.school-address-coordinates').val(`${lat}, ${lng}`);
}

function setupAddressField() {
  const selector = _.map(['street', 'npa', 'city'],
    value => `#school_address_attributes_${value}`).join(', ');
  $(selector).off('change').on('change', () => {
    const $inputs = $(selector);
    const $form = $inputs.parents('form');
    updateCoordinates($form, '', '');
    geocode(..._.map($inputs, 'value')).then(({ lat, lng }) => {
      updateCoordinates($form, lat, lng);
    }).catchReturn();
  });
}

$(document).on('ready turbolinks:load', () => {
  setupAddressField();
});
